import React, {
	useEffect,
	useState
} from 'react'

import CollapsiblePill from './CollapsiblePill'
import { QueryPillsProps } from './QueryPills'

const generateGroupWithArray = (list, key) => list.reduce((result, obj) => {
	const group = obj[key];
	const groupID = obj['id'];
	if (result[group]) {
		result[group].values.push(obj);
	} else {
		result[group] = {
			"group_name": group,
			"group_id": groupID,
			"values": [obj]
		}
	}

	console.log("result", result)
	return result;
}, {})

const QueryPillsV2 = (props) => {

	const [groupHide, setGroupHide] = useState({});
	const { testId = "cs-query-pills", filterPillsArr } = props
	const [pillGroups, setPillGroups] = useState(generateGroupWithArray(filterPillsArr, 'field'))




	useEffect(() => {
		setPillGroups(generateGroupWithArray(filterPillsArr, 'field'))
	}, [filterPillsArr])

	return (
		<>
			{Object.keys(pillGroups).map((pill_id, index) => (
				<CollapsiblePill {...props} isHide={groupHide[pillGroups[pill_id].group_id] || false} groupHide={groupHide} setGroupHide={setGroupHide} testIdPrefix={testId} testId={`${testId}-group-${pillGroups[pill_id].group_id}`} id={pillGroups[pill_id].group_id} group={pillGroups[pill_id]} />
			))}
		</>
	)
}

export default QueryPillsV2;